import $http from "@/axios/axios";

const actions = {
  UPDATE_DATA(context){
    context.dispatch('GET_POSTER');
    context.dispatch('GET_NEWS');
  },
  async GET_POSTER(context){
    try{
      let {data} = await $http.get('u_poster', {
        params: {
          buildings_id: context.rootGetters['appUser/client/aparts/selectedBuildingsId']
        }
      });
      context.commit('SET_POSTER', data);
    }
    catch(e){
      context.commit('SET_POSTER', null);
    }
  },
  async GET_NEWS(context){
    try{
      let {data} = await $http.get('u_news', {
        params: {
          buildings_id: context.rootGetters['appUser/client/aparts/selectedBuildingsId']
        }
      });
      context.commit('SET_NEWS', data);
    }
    catch(e){
      context.commit('SET_NEWS', []);
    }
  }
};

export default actions;